import { handleActions } from 'redux-actions';
import {
  setSelectedTierEntityId,
  setSelectedTierContentType,
} from '../actions/subscriptionsSection';
import { default as SubscriptionsSection } from '../../types/subscriptionsSection';

const defaultState: SubscriptionsSection = {
  selectedTierEntityId: null,
  tierContentType: undefined,
};

export default handleActions<SubscriptionsSection, any>(
  {
    [setSelectedTierContentType.toString()]: (
      state: SubscriptionsSection,
      action: ReturnType<typeof setSelectedTierContentType>
    ) => ({
      ...state,
      tierContentType: action.payload,
    }),
    [setSelectedTierEntityId.toString()]: (
      state: SubscriptionsSection,
      action: ReturnType<typeof setSelectedTierEntityId>
    ) => ({
      ...state,
      selectedTierEntityId: action.payload,
      tierContentType: undefined,
    }),
  },
  defaultState
);
